import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import AuthAxios from "../../config/authAxios"
import apiRoutes from "../apiConfigs";

export const modulePermissionApi = createAsyncThunk(
    'auth/modulePermissions',
    async (data = {}, { rejectWithValue }) => {
        try {
            const params = { page: 1, ...data };
            const response = await AuthAxios.get(apiRoutes.adminAction("roles_permissions/permissions", 1), { params })
            return { ...response?.data, page: Number(params.page), search: params.search || "" }
        } catch (error) {
            return rejectWithValue(error?.response?.data)
        }
    }
)
const initialState = { result: [], loading: false, error: null, message: "", total: 0, next: null, page: 0, search: "" }
const modulePermissionSlice = createSlice({
    name: 'modulePermission',
    initialState,
    reducers: {
        resetModulePermission: () => initialState
    },
    extraReducers: (builder) => {
        builder.addCase(modulePermissionApi.pending, (state, action) => {
            state.loading = true
            const currentPage = Number(action.meta.arg?.page || 1)

            if (currentPage === 1) {
                state.search = action.meta.arg?.search || ""
                state.result = []
                state.next = null
                state.page = 0
            }
        })
        builder.addCase(modulePermissionApi.fulfilled, (state, action) => {
            if ((action?.payload?.search || "") !== state.search) {
                return
            }

            state.loading = false
            const currentPage = action?.payload?.page || 1
            const results = action?.payload?.result || []
            const existingIds = new Set(currentPage === 1 ? [] : state.result.map((obj) => obj.id))

            state.result = currentPage === 1
                ? results
                : [
                    ...state.result,
                    ...results.filter((obj) => !existingIds.has(obj.id)),
                ]
            state.message = action?.payload?.message
            state.total = action?.payload?.count
            state.next = action?.payload?.next
            state.page = currentPage
        })
        builder.addCase(modulePermissionApi.rejected, (state, action) => {
            state.loading = false
            state.error = action?.payload?.error
            state.message = action?.payload?.message
        })
    },
})
export const { resetModulePermission } = modulePermissionSlice.actions
export const modulePermissionReducer = modulePermissionSlice.reducer
